import { Box, Checkbox, ScrollArea, Table } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { useDebouncedCallback } from "@mantine/hooks";
import cx from "clsx";
import React, { useCallback, useEffect, useState } from "react";
import {
  listBranch,
  tblPromotionCommand,
} from "../../../../../../model/TblPromotion";
import { getMasterOfSelect } from "../../../../../../service/getSelectApi";
import classes from "../../Styles/ScrollTable.module.css";

const SuperMarket = ({
  form,
}: {
  form: UseFormReturnType<
    tblPromotionCommand,
    (values: tblPromotionCommand) => tblPromotionCommand
  >;
}) => {
  const [dataTable, setDataTable] = useState<listBranch[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const getData = async () => {
      const _data = await getMasterOfSelect();
      if (_data) {
        const _dataTable = _data
          .filter((item) => item.text && item.text !== "Tất cả")
          .map((item) => {
            return {
              id: Number.parseInt(item.value),
              code: item.att2, // att2 = ma chi nhanh; item.value la id
              branchName: item.text,
              check: true,
            } as listBranch;
          });
        if (_dataTable.length > 0) {
          setDataTable(_dataTable);
          setSelectAll(true);
        }
      }
    };
    getData();
  }, []);

  // Chỉ gửi id chi nhánh xuống BE dạng "13,25,102"; mã và tên tra cứu lại từ danh mục khi cần hiển thị
  const handleSearch = useDebouncedCallback(() => {
    form.setFieldValue(
      "listBranch",
      dataTable
        .filter((item) => item.check === true)
        .map((item) => item.id)
        .join(",")
    );
  }, 500);

  useEffect(() => {
    handleSearch();
  }, [dataTable]);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight - 450);
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const handleCheckboxChange = useCallback(
    (index: number, checked: boolean | undefined) => {
      setDataTable((prev) => {
        // Cập nhật giá trị `check` cho phần tử tương ứng
        const updatedData = prev.map((item, i) =>
          i === index ? { ...item, check: checked } : item
        );

        // Sắp xếp lại danh sách sau khi cập nhật
        const sortedData = [...updatedData].sort((a, b) => {
          if (a.check && !b.check) return -1;
          if (!a.check && b.check) return 1;
          return 0;
        });

        // Trả về danh sách đã sắp xếp
        return sortedData;
      });
    },
    []
  );

  const handleSelectAll = useCallback(() => {
    setSelectAll((prev) => !prev);
    setDataTable((prev) => prev.map((item) => ({ ...item, check: !selectAll })));
  }, [selectAll]);

  return (
    <Box mt={10}>
      <ScrollArea h={height}>
        <Table style={{ overflowY: "auto", height: "30px" }}>
          <Table.Thead className={cx(classes.header)}>
            <Table.Tr>
              <Table.Th w={30}>
                <Checkbox checked={selectAll} onChange={handleSelectAll} />
              </Table.Th>
              <Table.Th w={140}>Mã chi nhánh</Table.Th>
              <Table.Th>Tên chi nhánh</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody mih={100}>
            {dataTable?.map((branch, index) => (
              <Table.Tr key={branch.id}>
                <Table.Td>
                  <Checkbox
                    checked={branch.check ?? false}
                    onChange={(event) =>
                      handleCheckboxChange(index, event.target.checked)
                    }
                  />
                </Table.Td>
                <Table.Td>{branch.code}</Table.Td>
                <Table.Td>{branch.branchName}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
          {dataTable.length < 1 && (
            <Table.Caption>Không có dữ liệu</Table.Caption>
          )}
        </Table>
      </ScrollArea>
    </Box>
  );
};

export default React.memo(SuperMarket);
